import { Box, Typography } from '@mui/material';

export const AUTH_GRADIENT = 'linear-gradient(135deg, #ff6b6b 0%, #ff9472 50%, #ffd166 100%)';
export const AUTH_ACCENT = '#ff6b6b';
export const AUTH_ACCENT_MID = '#ff9472';
export const AUTH_ACCENT_LIGHT = '#ffd166';

export const authBrandTextSx = {
  fontWeight: 900,
  letterSpacing: '-0.03em',
  background: AUTH_GRADIENT,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

export const authIconSx = { color: AUTH_ACCENT_MID };

export const authInputSx = {
  '& .MuiOutlinedInput-root': {
    color: '#111827',
    bgcolor: '#ffffff',
    borderRadius: '14px',
  },
  '& .MuiOutlinedInput-input': {
    color: '#111827',
  },
  '& .MuiOutlinedInput-input::placeholder': {
    color: 'rgba(17,24,39,0.55)',
    opacity: 1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(17,24,39,0.22)',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(17,24,39,0.34)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255,107,107,0.70)',
    boxShadow: '0 0 0 3px rgba(255,107,107,0.18)',
  },
};

export const authInputDisabledSx = {
  '& .MuiOutlinedInput-root': {
    color: 'rgba(255,255,255,0.7)',
    borderRadius: '14px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(255,255,255,0.14)',
  },
};

export const authLabelSx = {
  color: '#fff',
  fontWeight: 700,
  fontSize: '0.82rem',
  display: 'flex',
  alignItems: 'center',
  gap: 0.8,
  mb: 1,
};

export const authHintSx = {
  fontSize: '0.82rem',
  color: 'rgba(255,255,255,0.72)',
  fontWeight: 650,
  lineHeight: 1.5,
  mb: 0.5,
};

export const authSubtleTextSx = {
  fontSize: '0.78rem',
  color: 'rgba(255,255,255,0.60)',
  fontWeight: 600,
  lineHeight: 1.5,
};

export const authLinkBtnSx = {
  textTransform: 'none',
  fontWeight: 800,
  letterSpacing: '0.01em',
  color: AUTH_ACCENT_MID,
  '&:hover': {
    color: AUTH_ACCENT_LIGHT,
    backgroundColor: 'rgba(255,107,107,0.08)',
  },
};

export const authPrimaryBtnSx = {
  borderRadius: '14px',
  textTransform: 'none',
  fontWeight: 800,
  py: 1.35,
  mt: 0.5,
  letterSpacing: '0.01em',
  color: '#fff',
  background: AUTH_GRADIENT,
  boxShadow: '0 10px 24px rgba(255,107,107,0.28)',
  '&:hover': {
    background: AUTH_GRADIENT,
    filter: 'brightness(1.05)',
    boxShadow: '0 14px 30px rgba(255,107,107,0.36)',
  },
};

export const authOutlineBtnSx = {
  borderRadius: '14px',
  textTransform: 'none',
  fontWeight: 700,
  py: 1.35,
  color: AUTH_ACCENT_MID,
  borderColor: 'rgba(255,148,114,0.45)',
  backgroundColor: 'rgba(255,107,107,0.06)',
  '&:hover': {
    borderColor: AUTH_ACCENT,
    backgroundColor: 'rgba(255,107,107,0.12)',
  },
};

export function AuthDivider({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        my: 2,
        px: 0.5,
      }}
    >
      <Box sx={{ flex: 1, height: '1px', bgcolor: 'rgba(255,255,255,0.14)' }} />
      <Typography
        component="span"
        sx={{
          fontSize: '0.78rem',
          color: 'rgba(255,255,255,0.45)',
          fontWeight: 600,
          whiteSpace: 'nowrap',
          px: 0.5,
          lineHeight: 1.4,
        }}
      >
        {children}
      </Typography>
      <Box sx={{ flex: 1, height: '1px', bgcolor: 'rgba(255,255,255,0.14)' }} />
    </Box>
  );
}
